<template>
  <ChatModal title="Tag records" width="560px" @close="$emit('close')">
    <div v-if="value.length" class="mb-3">
      <div class="chat-label mb-1">Tagged in this message</div>
      <div v-for="t in value" :key="t.type + t.id" class="picked">
        <span class="picked-icon"><i :class="icon(t.type)"></i></span>
        <div style="min-width: 0; flex: 1">
          <div class="font-weight-bold text-truncate">{{ t.label }}</div>
          <small class="text-muted">{{ t.typeLabel }}<template v-if="t.sublabel"> · {{ t.sublabel }}</template></small>
        </div>
        <button type="button" class="btn btn-sm btn-link text-danger" title="Remove" @click="remove(t)">
          <i class="fe fe-x"></i>
        </button>
      </div>
    </div>

    <div class="chat-label mb-1">Find a record</div>
    <EntityTagPicker :types="types" class="picker-inline" @pick="add" @close="$emit('close')" />

    <div class="d-flex justify-content-end mt-3">
      <button type="button" class="btn chat-btn px-4" @click="$emit('close')">Done</button>
    </div>
  </ChatModal>
</template>

<script>
import ChatModal from "./ChatModal.vue";
import EntityTagPicker from "./EntityTagPicker.vue";
import { TYPE_ICONS } from "./TagsModal.vue";

const MAX_TAGS = 20;

// Pick the records to tag in the message being written (v-model: list of tags).
export default {
  name: "TagPickerModal",
  components: { ChatModal, EntityTagPicker },
  props: {
    value: { type: Array, default: () => [] },
    types: { type: Array, default: () => [] },
  },
  methods: {
    icon(type) {
      return TYPE_ICONS[type] || "fe fe-hash";
    },
    add(tag) {
      if (this.value.some((t) => t.type === tag.type && Number(t.id) === Number(tag.id))) return;
      if (this.value.length >= MAX_TAGS) {
        this.$toasted.info(`You can tag up to ${MAX_TAGS} records in one message.`, { position: "top-center", duration: 3000 });
        return;
      }
      this.$emit("input", this.value.concat([tag]));
    },
    remove(tag) {
      this.$emit("input", this.value.filter((t) => t !== tag));
    },
  },
};
</script>

<style scoped>
.picked {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 4px;
}
.picked-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: #eef2ff;
  color: #2563eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.picker-inline {
  border: 1px solid #e2e8f0;
  box-shadow: none !important;
}
</style>
